import { render, staticRenderFns } from "./WhatsappLink.vue?vue&type=template&id=4f301f28&scoped=true&"
import script from "./WhatsappLink.vue?vue&type=script&lang=js&"
export * from "./WhatsappLink.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappLink.vue?vue&type=style&index=0&id=4f301f28&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f301f28",
  null
  
)

export default component.exports